import React, { useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import Navbar from "./Components/Navbar";
import Home from "./Components/Home";
import About from "./Components/About";
import Contact from "./Components/Contact";
import Services from "./Components/Services";
import BookNow from "./Components/BookNow";
import Footer from "./Components/Footer";
import ScrollTop from "./Components/ScrollTop";

// Custom hook to refresh AOS on route change
function useAOSRefresh() {
  const location = useLocation();

  useEffect(() => {
    AOS.init({ duration: 800, once: false });
    AOS.refresh();
  }, [location]);
}

function AppContent() {
  useAOSRefresh();

  return (
    <>
      <ScrollTop />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/services" element={<Services />} />
        <Route path="/booknow" element={<BookNow />} />
      </Routes>
      <Footer />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
